// import { uuid } from 'vue-uuid';
import { computed, ref } from 'vue';
// import { onSnapshot, updateDoc, collection, doc, getDoc } from 'firebase/firestore';
// import { db } from '@/firebase';
// import store from '@/store';
// const merchant = computed(() => store.getters.merchant);
import {
  setPointCategory,
  updatePointCategory,
  updateCategoryVisibility,
  dndPointCategories,
  deletePointCategory,
  setNewProduct,
  axDeleteProduct,
  dndProducts,
  axUpdateProduct,
  axUpdateProductVisibility,
  axUpdateProductWeightAdjustable,
} from '@/services/categories.axios.service';
import axiosInstance from './axios.service';
export const selectedPoint = ref(null);
export const currentAccordionItem = ref();
export const inputCategory = ref('');
export const isModalOpen = ref(false);

export const checkCurrentItem = computed(() => (indx) => currentAccordionItem.value === indx);

export function resetCategoriesServiceState() {
  selectedPoint.value = null;
  currentAccordionItem.value = null;
  inputCategory.value = '';
  isModalOpen.value = false;
}

/* ==_addNewCategory_== */
export async function addNewCategory(pointId) {
  if (inputCategory.value) {
    const newCategory = {
      pointId,
      name: inputCategory.value,
      isVisible: true,
    };
    try {
      const res = await setPointCategory(newCategory);
      console.log('addNewCategory:res', res);
      isModalOpen.value = false;
      inputCategory.value = '';
      res.type = 'added';
      return res;
    } catch (error) {
      console.error(error);
    }
  }
}
function resolveVisibleForOperator(source, fallback = true) {
  if (source?.visibleForOperator !== undefined) return source.visibleForOperator;
  if (source?.isVisible !== undefined) return source.isVisible;
  return fallback;
}

function resolveVisibilityValue(source, visibilityField) {
  if (source?.[visibilityField] !== undefined) return source[visibilityField];
  if (visibilityField === 'visibleForCustomer') return source?.isVisible;
  return undefined;
}

export async function updateCategory(id, nameOrVisible, maybeVisible, visibilityOptions = {}) {
  let isVisible = nameOrVisible;
  let name = '';

  // Handle argument variations:
  // 1. updateCategory(id, name, isVisible) - called from Categories.vue toggle
  // 2. updateCategory(id) - called from fnUpdateCategory when editing name (inputCategory.value used)

  if (typeof nameOrVisible === 'string' && typeof maybeVisible === 'boolean') {
    // Case 1: Called with (id, name, isVisible)
    isVisible = maybeVisible;
    name = nameOrVisible;
  } else if (typeof nameOrVisible === 'boolean') {
    // Case 3: Called with (id, isVisible) - potentially
    isVisible = nameOrVisible;
  }

  if (inputCategory.value) {
    // Renaming logic (using global state inputCategory)
    const updCategory = {
      id: id,
      name: inputCategory.value,
    };
    try {
      const res = await updatePointCategory(updCategory);
      console.log('updCategory:res', res);
      isModalOpen.value = false;
      inputCategory.value = '';
      res.type = 'updated';
      return res;
    } catch (error) {
      console.error(error);
    }
  } else {
    // Visibility toggle logic
    try {
      console.log('updateCategory:toggle:id', id);
      console.log('updateCategory:toggle:isVisible', isVisible);

      const visibilityField = visibilityOptions.visibilityField || 'visibleForCustomer';
      const payload = {
        categoryId: id,
      };

      payload[visibilityField] = isVisible;
      if (visibilityField === 'visibleForCustomer') {
        payload.visibleForOperator = resolveVisibleForOperator(visibilityOptions, true);
      }

      const res = await updateCategoryVisibility(payload);
      const result = res || {};
      result.type = 'changeVisible';
      result.isVisible = isVisible;
      return result;
    } catch (error) {
      console.error(error);
    }
  }
}

export async function shiftCategories(dataForUpdate) {
  try {
    console.log('======>>>>>', dataForUpdate);

    const res = await dndPointCategories(dataForUpdate);
    res.type = 'dndCategories';
    return res;
  } catch (error) {
    console.error(error);
  }
}
// dndProduct
export async function shiftProducts(dataForUpdate) {
  try {
    console.log('======>>>>>', dataForUpdate);

    const res = await dndProducts(dataForUpdate);
    res.type = 'dndProducts';
    return res;
  } catch (error) {
    console.error(error);
  }
}
export async function deleteCategory(dataForDelete) {
  try {
    const res = await deletePointCategory(dataForDelete);
    res.type = 'categoryDelete';
    return res;
  } catch (error) {
    console.error(error);
  }
}
export async function deleteProduct(dataForDelete) {
  try {
    // dataForDelete typically is { id: "..." } from Categories.vue
    const res = await axDeleteProduct({
      id: dataForDelete.id,
    });
    res.type = 'productDelete';
    return res;
  } catch (error) {
    console.error(error);
  }
}
// deleteProduct
export async function addNewProduct(product) {
  try {
    // Sanitize payload for creation to match schema
    const payload = {
      name: product.name,
      pointId: product.pointId,
      price: product.price || 0,
      categoryId: product.categoryId || null,
      chips: product.chips || [],
      departmentId: product.departmentId || null,
      description: product.description || '',
      externalId: product.externalId || '',
      externalSizeId: product.externalSizeId || '',
      imgUrl: product.imgUrl || '',
      isVisible: product.isVisible ?? true,
      adultsOnly: product.adultsOnly ?? false,
      sizeId: product.sizeId || '',
      sku: product.sku || '',
      step: product.step || 0,
      unit: product.unit || 'item',
    };

    // Remove empty strings if schema expects specific length or null
    if (payload.categoryId === '') payload.categoryId = null;
    if (payload.departmentId === '') payload.departmentId = null;

    const res = await setNewProduct(payload);
    console.log('addNewCategory:res', res);
    isModalOpen.value = false;
    inputCategory.value = '';
    res.type = 'addProduct';
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export async function updateProductVisibility(product, visibilityField = 'visibleForCustomer') {
  const isVisible = resolveVisibilityValue(product, visibilityField);
  const objForUpdate = {
    productId: product.id,
  };

  objForUpdate[visibilityField] = isVisible;
  if (visibilityField === 'visibleForCustomer') {
    objForUpdate.visibleForOperator = resolveVisibleForOperator(product, true);
  }

  try {
    const res = await axUpdateProductVisibility(objForUpdate);
    const result = res || {};
    isModalOpen.value = false;
    inputCategory.value = '';
    result.type = 'updateProduct';
    result.isVisible = isVisible;
    return result;
  } catch (error) {
    console.error(error);
  }
}

export async function updateProductWeightAdjustable(product) {
  try {
    const res = await axUpdateProductWeightAdjustable({
      productId: product.id,
      weightAdjustable: Boolean(product.weightAdjustable),
    });
    const result = res || {};
    result.type = 'updateProductWeightAdjustable';
    result.weightAdjustable = Boolean(product.weightAdjustable);
    return result;
  } catch (error) {
    console.error(error);
  }
}

export async function updateOneProduct(product) {
  try {
    const payload = {
      id: product.id,
      name: product.name || '',
      price: product.price || 0,
      isVisible: product.isVisible ?? true,
    };

    if (product.departmentId !== undefined) payload.departmentId = product.departmentId || null;
    if (product.externalId !== undefined) payload.externalId = product.externalId || '';
    if (product.sizeId !== undefined) payload.sizeId = product.sizeId || '';
    if (product.externalSizeId !== undefined) payload.externalSizeId = product.externalSizeId || '';
    if (product.sku !== undefined) payload.sku = product.sku || '';
    if (product.description !== undefined) payload.description = product.description || '';
    if (product.imgUrl !== undefined) payload.imgUrl = product.imgUrl;
    if (product.chips !== undefined) payload.chips = product.chips || [];
    if (product.step !== undefined) payload.step = product.step || 0;
    if (product.unit !== undefined) payload.unit = product.unit || 'item';
    if (product.categoryId !== undefined) payload.categoryId = product.categoryId || null;
    if (product.adultsOnly !== undefined) payload.adultsOnly = product.adultsOnly ?? false;

    // Remove empty strings for IDs that might have strict length validators
    if (payload.departmentId === '') payload.departmentId = null;
    if (payload.categoryId === '') payload.categoryId = null;

    // If deleted is passed explicitly, include it
    if (product.deleted !== undefined) {
      payload.deleted = product.deleted;
    }

    const res = await axUpdateProduct(payload);
    res.type = 'updateProduct';
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
